import { request } from 'lib/api'
import { HTTP_METHODS } from './const'

class DailyCheckIn {
  static updateDailyCheckIn({
    day,
    event_name,
    previous_streak_status,
    more_rewards_event_name,
  }) {
    return request({
      withCacheControl: false,
      url: 'v7/daily-check-in',
      method: HTTP_METHODS.post,
      xHeaders: {
        'Cache-Control': 'no-store, no-cache, must-revalidate, max-age=0',
      },
      body: {
        day,
        event_name,
        previous_streak_status,
        more_rewards_event_name,
      },
    })
  }

  static getDailyCheckIn() {
    return request({
      withCacheControl: false,
      xHeaders: {
        'Cache-Control': 'no-store, no-cache, must-revalidate, max-age=0',
      },
      url: 'v7/daily-check-in',
      method: HTTP_METHODS.get,
    })
  }
}

export default DailyCheckIn
